export const generalExtendedStatus = {
  Paid: 'paid',
  NoDebt: 'no-debt',
  NotPaid: 'not-paid',
  Canceled: 'canceled'
};

export const debtExtendedStatus = {
  NoDebt: generalExtendedStatus.NoDebt,
  NotPaid: generalExtendedStatus.NotPaid,
  Canceled: generalExtendedStatus.Canceled
};

export type DebtExtendedInformationStatus = typeof debtExtendedStatus[keyof typeof debtExtendedStatus];

export class TripDebtExtendedInformationModel {
  status: DebtExtendedInformationStatus;
  amount: number;
  currencyCode: string;
  canceledByUserId: number;
  canceledByUserLogin: string;
  cancelDescription: string;
  canceledAtTimestamp: number;
}

export const penaltyExtendedStatus = {
  Paid: generalExtendedStatus.Paid,
  NotPaid: generalExtendedStatus.NotPaid,
  Canceled: generalExtendedStatus.Canceled
};

export type PenaltyExtendedInformationStatus = typeof penaltyExtendedStatus[keyof typeof penaltyExtendedStatus];

export class PenaltyExtendedInformationModel {
  status: PenaltyExtendedInformationStatus;
  intervalId: number;
  amount: number;
  currencyCode: string;
  createdByUserId: number;
  createdByUserLogin: string;
  createdAtTimestamp: number;
  penaltyDescription: string;
  canceledByUserId: number;
  canceledByUserLogin: string;
  canceledByAtTimestamp: number;
  penaltyCancellationDescription: string;
}
